import DiceRoll from "./DiceRoll";
import DiceRollGroup from "./DiceRollGroup";

export * from "./DiceRollGroup";
export { DiceRollGroup, DiceRoll };

export default DiceRollGroup;
